
















import Vue, { PropType } from 'vue'

import * as Draggable from 'vuedraggable'

import { WidgetSettingsSortableList } from '../widgets/base/widget/WidgetInterface'

export default Vue.extend({
  components: {
    Draggable
  },
  props: {
    value: {
      type: Array,
      required: true,
      default: []
    },
    setting: {
      type: Object as PropType<WidgetSettingsSortableList>,
      required: true,
      default: {}
    }
  },
  methods: {
    onUpdateSorting() {
      const list = this.setting.list ? this.setting.list : []
      this.$emit('change', list)
    },
  }
})
